import type {ReactNode} from "react";

import {ABTestContainer} from "@pg-mono/ab-testing";

import {abTestingInstance} from "../../ab_testing/ab_testing_instance";
import {OngoingABTests} from "../../ab_testing/ongoing_ab_tests";

const abTestInstanceProps = abTestingInstance.getABTestContainerProps(OngoingABTests.PROPERTY_SHOW_BUTTONS);

interface IProps {
    children: (() => ReactNode)[];
}

export const PropertyShowButtonsTestContainer = (props: IProps) => {
    return (
        <ABTestContainer {...abTestInstanceProps} pushEventOnlyOnce>
            {props.children}
        </ABTestContainer>
    );
};
import type {ReactNode} from "react";

import {ABTestContainer} from "@pg-mono/ab-testing";

import {abTestingInstance} from "../../ab_testing/ab_testing_instance";
import {OngoingABTests} from "../../ab_testing/ongoing_ab_tests";

const abTestInstanceProps = abTestingInstance.getABTestContainerProps(OngoingABTests.PROPERTY_SHOW_BUTTONS);

interface IProps {
    children: (() => ReactNode)[];
}

export const PropertyShowButtonsTestContainer = (props: IProps) => {
    return (
        <ABTestContainer {...abTestInstanceProps} pushEventOnlyOnce>
            {props.children}
        </ABTestContainer>
    );
};
